import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { NepaliDatePicker } from 'nepali-datepicker-reactjs';
import 'nepali-datepicker-reactjs/dist/index.css';
import './BSDateInput.css';

/**
 * BSDateInput - Nepali (BS) date picker only
 * Saves BS dates to database
 * Styled to match Material-UI TextField
 */
const BSDateInput = ({ 
  label = "Date", 
  value, 
  onChange, 
  required = false,
  disabled = false 
}) => {
  const [bsDate, setBsDate] = useState('');

  useEffect(() => {
    if (value) {
      setBsDate(value);
    }
  }, [value]);

  const handleBSChange = (value) => {
    if (!value) return;
    
    let newBsDate = value;
    
    if (typeof value === 'object' && value.bsDate) {
      newBsDate = value.bsDate;
    } else if (typeof value === 'object' && value.year) {
      newBsDate = `${value.year}-${String(value.month).padStart(2, '0')}-${String(value.day).padStart(2, '0')}`;
    } else if (typeof value === 'string') {
      newBsDate = value;
    }
    
    setBsDate(newBsDate);
    if (onChange) {
      onChange(newBsDate);
    }
  };

  return (
    <Box className="bs-date-wrapper" sx={{ width: '100%', position: 'relative' }}>
      {/* Floating label */}
      <Typography 
        variant="caption" 
        className="bs-date-label"
        sx={{ 
          position: 'absolute',
          top: '-8px',
          left: '12px',
          padding: '0 4px',
          fontSize: '0.75rem',
          zIndex: 1
        }}
      >
        {label} {required && <span className="bs-date-required">*</span>}
      </Typography>
      
      <NepaliDatePicker
        onChange={handleBSChange}
        value={bsDate}
        disabled={disabled}
        inputClassName="bs-date-input"
        placeholder=""
        options={{ 
          calenderLocale: 'en',
          valueLocale: 'en',
          closeOnSelect: true
        }}
      />
    </Box>
  );
};

export default BSDateInput;
